// extracted by mini-css-extract-plugin
export default {"logo":"Spinner_logo__6vF5j","container":"Spinner_container__N54uS","spinner":"Spinner_spinner__+wbRe","rotate":"Spinner_rotate__rCLeS"};